// tslint:disable
export var ContactInfoType;
(function (ContactInfoType) {
    // UNKN
    ContactInfoType[ContactInfoType["UNKNOWN"] = 0] = "UNKNOWN";
    // PHONE
    ContactInfoType[ContactInfoType["PHONE"] = 1] = "PHONE";
    // MOBILE
    ContactInfoType[ContactInfoType["MOBILE"] = 2] = "MOBILE";
    // FAX
    ContactInfoType[ContactInfoType["FAX"] = 3] = "FAX";
    // WEB
    ContactInfoType[ContactInfoType["WEB"] = 4] = "WEB";
    // E-MAIL
    ContactInfoType[ContactInfoType["EMAIL"] = 5] = "EMAIL";
    // DNC
    ContactInfoType[ContactInfoType["DONOTCALL"] = 6] = "DONOTCALL";
    // FACEBOOK
    ContactInfoType[ContactInfoType["FACEBOOK"] = 7] = "FACEBOOK";
    // TWITTER
    ContactInfoType[ContactInfoType["TWITTER"] = 8] = "TWITTER";
    // LINKEDIN
    ContactInfoType[ContactInfoType["LINKEDIN"] = 9] = "LINKEDIN";
    // GOOGLEPLUS
    ContactInfoType[ContactInfoType["GOOGLEPLUS"] = 10] = "GOOGLEPLUS";
    // YOUTUBE
    ContactInfoType[ContactInfoType["YOUTUBE"] = 11] = "YOUTUBE";
    // Text
    ContactInfoType[ContactInfoType["Text"] = 12] = "Text";
    // Mail
    ContactInfoType[ContactInfoType["Mail"] = 13] = "Mail";
    // MANGO
    ContactInfoType[ContactInfoType["MANGO"] = 14] = "MANGO";
})(ContactInfoType || (ContactInfoType = {}));
ContactInfoType['TEXT'] = 12;
ContactInfoType['MAIL'] = 13;
//# sourceMappingURL=ContactInfoType.js.map